module.exports = __webpack_public_path__ + "static/img/13.8bd311b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/13.png
// module id = PPI6
// module chunks = 0